import React from 'react'
import { makeStyles } from '@material-ui/core'


const useStyles = makeStyles({
  root: {
    height: '100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain'
  }
})

export default function ImageSection(props){

  const classes = useStyles()

  const { image } = props

  return (
    <div className={classes.root} style={{backgroundImage: `url(${image})`}}/>
  )
}